export default "__VITE_ASSET__LQLtSWbq__"